import { ListarTiposDocumentoEntradaRespostaItem, ObterDadosPlanoPagamentoResposta } from "app/api/classes/OrcamentoApi"
import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { PlanoPagamentoFormulario } from "app/types/AbaPlanoPagamento"
import React, { useEffect, useState } from "react"
import { AbaPlanoPagamento } from "./aba-plano-pagamento/AbaPlanoPagamento"
import { obterPermissao } from "app/use-cases/obterPermissao"
import {
    definirCarenciaPlanoPagamento as definirCarenciaPlanoPagamentoUseCase, definirParcelaPlanoPagamento as definirParcelaPlanoPagamentoUseCase, definirPlanoPagamento as definirPlanoPagamentoUseCase, gerarParcelasPlanoPagamento,
    removerPlanoPagamento as removerPlanoPagamentoUseCase
} from "app/use-cases/orcamento/alteracoesPlanoPlagamento"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { EditarParcelaContratoContainer } from "./editar-parcela-contrato/EditarParcelaContratoContainer"
import { IncluirEditarParcelaContainer } from "./incluir-editar-parcela/IncluirEditarParcelaContainer"
import { SimularFinanciamentoContainer } from "./simular-financiamento/SimularFinanciamentoContainer"
import { TelaFormaDePagamentoContainer } from "./TelaFormaDePagamentoContainer"

export type PlanoDePagamentoContainerProps = {
    somenteLeitura?:boolean,
    mostrarDadosDeContratoPorPadrao?:boolean
    executarAcaoLimpar?:boolean
}

export const PlanoDePagamentoContainer = (props: PlanoDePagamentoContainerProps) => {
    const orcamento = useAppSelector(state => state.orcamento)

    const [dadosPlano, setDadosPlano] = useState<PlanoPagamentoFormulario>({})
    const [informacoesPlanosPagamento, setInformacoesPlanosPagamento] = useState<ObterDadosPlanoPagamentoResposta>({} as ObterDadosPlanoPagamentoResposta)
    const [mostrarBotaoSimularFinanciamento, setMostrarBotaoSimularFinanciamento] = useState(false)
    const [tiposDocumentoEntrada, setTiposDocumentoEntrada] = useState<ListarTiposDocumentoEntradaRespostaItem[]>([])

    const atualizarTiposDocumentoEntrada = async (comEntrada:boolean) => {
        setTiposDocumentoEntrada(
            comEntrada ? await microuniversoApi.Orcamento.listarTiposDocumentoEntrada(orcamento.IdentificadorOrcamento) : []
        )
    }

    const comEntradaModificado = async (comEntrada:boolean) => {
        atualizarTiposDocumentoEntrada(comEntrada)
    }

    const atualizarMostrarBotaoSimularFinanciamento = async () => {
        setMostrarBotaoSimularFinanciamento(
            await obterPermissao({
                funcionalidade: "ORCAMENTO_PLANO_PAGAMENTO",
                acao: "SIMULAR_FINANCIAMENTO"
            })
        )
    }

    const atualizarInformacoesPlanosPagamento = async (atualizarDadosFormulario: boolean) => {
        const informacoesPlanoAtualizadas = await microuniversoApi.Orcamento.obterDadosPlanoPagamento(orcamento.IdentificadorOrcamento)

        if ("HasErrors" in informacoesPlanoAtualizadas) {
            setInformacoesPlanosPagamento(informacoesPlanosPagamentos => ({
                ...informacoesPlanosPagamentos,
                ParcelasPlanoPagamento: [],
                Carencias: []

            }))
            return
        }

        setInformacoesPlanosPagamento(informacoesPlanoAtualizadas)

        if (atualizarDadosFormulario) {

            setDadosPlano({
                CodigoCarencia: informacoesPlanoAtualizadas.CodigoCarencia,
                CodigoParcela: informacoesPlanoAtualizadas.CodigoParcela,
                CodigoPlanoPagamento: informacoesPlanoAtualizadas.CodigoPlanoPagamento,
                ComEntrada: informacoesPlanoAtualizadas.ComEntrada,
                CodigoDocumentoEntrada: informacoesPlanoAtualizadas.CodigoDocumentoEntrada,
                ValorEntrada: informacoesPlanoAtualizadas.ValorEntrada
            })
        }
    }

    const planoPagamentoModificado = async (codigoPlanoPagamento:string) => {

        setDadosPlano(dadosPlano => ({
            ...dadosPlano,
            CodigoPlanoPagamento: Number(codigoPlanoPagamento)
        }))

        await definirPlanoPagamentoUseCase({codigoPlanoPagamento})

        await atualizarInformacoesPlanosPagamento(false)
    }

    const numeroParcelasModificado = async (codigoNumeroParcelas:number) => {

        setDadosPlano(dadosPlano => ({
            ...dadosPlano,
            CodigoParcela: codigoNumeroParcelas
        }))

        
        await definirParcelaPlanoPagamentoUseCase({
            codigoNumeroParcelas
        })

        await atualizarInformacoesPlanosPagamento(false)
    }

    const diasCarenciaModificado = async (codigoDiasCarencia:number) => {

        setDadosPlano({
            ...dadosPlano,
            CodigoCarencia: codigoDiasCarencia
        })
        
        await definirCarenciaPlanoPagamentoUseCase({
            codigoCarencia: codigoDiasCarencia
        })
    }

    const gerarParcelas = async (dadosPlano_: PlanoPagamentoFormulario) => {

        const dadosPlanoAtualizados = {
            ...dadosPlano,
            ...dadosPlano_
        }

        setDadosPlano(dadosPlanoAtualizados)
        
        await gerarParcelasPlanoPagamento(dadosPlanoAtualizados)

        await atualizarInformacoesPlanosPagamento(false)
    }

    const editarParcela = (codigoParcela:number) => {
        renderizarComponentReact(
            <EditarParcelaContratoContainer
                somenteLeitura={props.somenteLeitura}
                parcela={(informacoesPlanosPagamento?.Contrato?.ParcelasFinanciamento ?? []).find(p => p.Codigo == codigoParcela)}/>,
            "conteudo-pagina",
            true
        )
    }

    const simularPreco = () => {
        renderizarComponentReact(
            <SimularFinanciamentoContainer/>,
            "conteudo-pagina",
            true
        )
    }

    const removerPlanoPagamento = async () => {
        await removerPlanoPagamentoUseCase({
            identificadorOrcamento: orcamento.IdentificadorOrcamento
        })

        await atualizarInformacoesPlanosPagamento(true)
    }

    const editarParcelaEntrada = () => {
        
        renderizarComponentReact(
            <IncluirEditarParcelaContainer 
                somenteLeitura={props.somenteLeitura}
                editandoPlanoPagamento={true} 
                indiceParcela={0} 
                parcela={informacoesPlanosPagamento.Entrada}
                onParcelaAtualizada={() => {
                    renderizarComponentReact(
                        <TelaFormaDePagamentoContainer
                            somenteLeitura={props.somenteLeitura}
                            abaSelecionada="Plano de Pagamento"/>,
                        "conteudo-pagina",
                        true
                    )
                }}/>,
            "conteudo-pagina",
            true
        )
    }

    useEffect(() => {
        atualizarInformacoesPlanosPagamento(true)
        atualizarMostrarBotaoSimularFinanciamento()
    },[])

    useEffect(() => {
        atualizarTiposDocumentoEntrada(dadosPlano.ComEntrada)
    },[dadosPlano.ComEntrada])

    useEffect(() => {
        if (props.executarAcaoLimpar === true) {
            removerPlanoPagamento()
        }
    }, [props.executarAcaoLimpar])

    return <>
        <AbaPlanoPagamento 
            somenteLeitura={props.somenteLeitura}
            planoPagamentoFormulario={dadosPlano}
            planosPagamento={informacoesPlanosPagamento?.PlanosPagamento ?? []}
            numerosParcelas={informacoesPlanosPagamento?.ParcelasPlanoPagamento ?? []}
            diasCarencia={informacoesPlanosPagamento?.Carencias ?? []}
            nomeDocumentoPlanoPagamento={orcamento.NomeDocumentoPlanoPagamento}
            orcamentoPlanoPagamento={false}
            simularFinanciamento={false}
            contrato={informacoesPlanosPagamento?.Contrato}
            onSimularPreco={simularPreco}
            onGerarParcela={gerarParcelas}
            onEditarParcela={editarParcela}
            onPlanoPagamentoSelecionado={planoPagamentoModificado}
            onNumeroParcelasSelecionado={numeroParcelasModificado}
            onDiasCarenciaSelecionado={diasCarenciaModificado}
            onErrorValidacao={() => { } }
            mostrarDadosDeContratoPorPadrao={props.mostrarDadosDeContratoPorPadrao} 
            mostrarBotaoSimularFinanciamento={mostrarBotaoSimularFinanciamento}
            onComEntradaEntradaSelecionado={comEntradaModificado}
            tiposDocumentoEntrada={tiposDocumentoEntrada}
            entrada={informacoesPlanosPagamento?.Entrada}
            onEditarParcelaEntrada={editarParcelaEntrada}/>
    </>
}